import { useState, useEffect, useCallback } from "react";

export function useOtpResendCooldown(initialSeconds = 60) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const timer = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);

  const startCooldown = useCallback((seconds = 60) => {
    setSecondsLeft(seconds);
  }, []);

  return {
    secondsLeft,
    isOnCooldown: secondsLeft > 0,
    startCooldown,
  };
}
